<template>
  <div class="bg-white-900 mb-14 mt-2">
    <div class="container mx-auto">
      <base-breadcrumbs :links-list="breadcrumbsList" class="mb-6" />
      <h1 class="capitalize text-5xl text-black-900 mb-5">
        Shortlist of Epigram Bookshops Catalogs
      </h1>
      <actions-bar
        select-type="catalogs"
        title="Catalogs total: 340"
        title-class="text-2xl"
        placeholder="Search by name"
      />
      <list-catalogs class="mb-13" />
    </div>
    <sticky-buttons />
  </div>
</template>

<script>
import ActionsBar from "@/components/base/ActionsBar.vue";
import Breadcrumbs from "@/components/base/Breadcrumbs.vue";
import StickyButtons from "@/components/base/StickyButtons.vue";
import TabCatalogs from "@/components/tabs/Catalogs.vue";

export default {
  name: "ShortlistCatalogs",
  components: {
    "actions-bar": ActionsBar,
    "base-breadcrumbs": Breadcrumbs,
    "sticky-buttons": StickyButtons,
    "list-catalogs": TabCatalogs,
  },
  data() {
    return {
      breadcrumbsList: [
        {
          href: "/shortlist",
          text: "Shortlist",
        },
        {
          href: "/shortlist/1/catalogs",
          text: "Epigram Bookshops Сatalogs",
        },
      ],
    };
  },
};
</script>
